import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmDialogModule } from '@portal-core/general/components/confirm-dialog/confirm-dialog.module';
import { ErrorDialogModule } from '@portal-core/general/components/error-dialog/error-dialog.module';
import { FlareFileReviewerToolbarContentComponent } from './flare-file-reviewer-toolbar-content.component';

@NgModule({
  declarations: [FlareFileReviewerToolbarContentComponent],
  imports: [
    CommonModule,
    ConfirmDialogModule,
    ErrorDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [FlareFileReviewerToolbarContentComponent]
})
export class FlareFileReviewerToolbarContentModule { }
